<template>
  <div class="app-container">
    <el-card class="weather-compare">
      <template #header>
        <el-form inline size="small">
          <el-form-item :label="$t('text.kssj')" class="search-form">
            <el-date-picker
              v-model="queryParams.startTime"
              type="date"
              :placeholder="$t('placeholder.xzrq')"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item :label="$t('text.jssj')">
            <el-date-picker
              v-model="queryParams.endTime"
              type="date"
              :placeholder="$t('placeholder.xzrq')"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item :label="$t('text.kssj')">
            <el-button
              type="primary"
              icon="el-icon-search"
              style="background-color: #00C49C; border-color: #00C49C;"
              @click="handleQuery"
            >{{ $t('button.cx') }}</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #default>
        <div id="weather_compare_div" style="height:100%" />
      </template>
    </el-card>
  </div>
</template>
<script>

import { GetWeatherHistorys, QueryWeathereReals } from '@/api/Weather'
import dayjs from 'dayjs'
import echarts from 'echarts'
const chartColor = ['#bc589e', '#cb2d3e', '#00d3a2', '#f85f35', '#435d9a', '#a3cf6a', '#f9ed60']
const chartAxisName = ['气压', '风向', '温度', '湿度', '风速', '辐射', '贴片温度']
const chartAxisUnit = ['kpa', '°', '℃', '%rh', 'm/s', 'w/m²', '℃']
export default {
  name: 'WeatherCompare',
  data () {
    return {
      queryParams: {
        orgid: this.$store.getters.station.id,
        startTime: new Date(),
        endTime: new Date(),
      },
      deviceList: [],
      chartOptions: {
        title: {
          text: '气象仪',
          textStyle: {
            color: '#ffffff'
          },
          top: 0,
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: function (params) {
            const result = [params[0].name].concat(params.map((item, index) => {
              return `${item.marker} ${item.seriesName}: ${item.value} ${chartAxisUnit[item.seriesIndex]}`
            })).join('<br>')
            return result
          }
        },
        grid: {
          left: 50,
          containLabel: true
        },
        color: chartColor,
        legend: {
          icon: 'circle',
          top: 30,
          textStyle: {
            color: '#ffffff'
          },
          data: chartAxisName
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月'
            ],
            axisLabel: {
              color: '#ffffff'
            },
            axisLine: {
              lineStyle: {
                color: '#21a675'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: chartAxisName[0],
            show: true,
            offset: 0,
            axisLabel: {
              formatter: '{value} kpa',
              color: chartColor[0]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[0]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[1],
            show: true,
            offset: 0,
            axisLabel: {
              formatter: '{value} °',
              color: chartColor[1]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[1]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[2],
            show: true,
            offset: 65,
            axisLabel: {
              formatter: '{value} ℃',
              color: chartColor[2]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[2]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[3],
            show: true,
            offset: 130,
            axisLabel: {
              formatter: '{value} %rh',
              color: chartColor[3]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[3]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[4],
            show: true,
            offset: 195,
            axisLabel: {
              formatter: '{value} m/s',
              color: chartColor[4]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[4]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[5],
            show: true,
            offset: 260,
            axisLabel: {
              formatter: '{value} w/m²',
              color: chartColor[5]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[5]
              }
            }
          },
          {
            type: 'value',
            name: chartAxisName[6],
            show: true,
            offset: 325,
            axisLabel: {
              formatter: '{value} ℃',
              color: chartColor[6]
            },
            axisLine: {
              lineStyle: {
                color: chartColor[6]
              }
            }
          }
        ],
        series: [
          {
            name: chartAxisName[0],
            type: 'line',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[1],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[2],
            type: 'line',
            smooth: true,
            yAxisIndex: 2,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[3],
            type: 'line',
            smooth: true,
            yAxisIndex: 3,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[4],
            type: 'line',
            smooth: true,
            yAxisIndex: 4,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[5],
            type: 'line',
            smooth: true,
            yAxisIndex: 5,
            showSymbol: false,
            data: []
          },
          {
            name: chartAxisName[6],
            type: 'line',
            smooth: true,
            yAxisIndex: 6,
            showSymbol: false,
            data: []
          }
        ]
      },
      chartDataSource: [],
      fullLoading: null,
      chartInstance: null
    }
  },
  mounted () {
    this.queryDeviceList().then(() => {
      this.queryHistoryData()
    })
  },
  methods: {

    /**
     * 设置图表组件的数据源
     * @param response
     */
    setChartSeriesData (response) {
      response.sort((a, b) => new Date(a.sitetime) - new Date(b.sitetime))
      this.chartOptions.xAxis[0].data = []
      this.chartOptions.series[0].data = []
      this.chartOptions.series[1].data = []
      this.chartOptions.series[2].data = []
      this.chartOptions.series[3].data = []
      this.chartOptions.series[4].data = []
      this.chartOptions.series[5].data = []
      this.chartOptions.series[6].data = []
      response.map(item => {
        this.chartOptions.xAxis[0].data.push(dayjs(item.sitetime).format('HH:mm:ss'))
        this.chartOptions.series[0].data.push(item.airpressure)
        this.chartOptions.series[1].data.push(item.winddirection)
        this.chartOptions.series[2].data.push(item.temperature)
        this.chartOptions.series[3].data.push(item.humidity)
        this.chartOptions.series[4].data.push(item.windspeed)
        this.chartOptions.series[5].data.push(item.sunshine)
        this.chartOptions.series[6].data.push(item.pathtemper)
      })
      this.renderChart()
    },

    /**
     * 获取设备列表
     */
    queryDeviceList () {
      this.loading().open()
      return new Promise((resolve, reject) => {
        QueryWeathereReals({
          page: 1,
          perpage: 10,
          orderBy: '',
          whereCondition: JSON.stringify({ orgid: this.$store.getters.station.id })
        }).then(({ data }) => {
          this.deviceList = data.queryResults
          resolve()
        }).catch(() => {
          reject()
        }).finally(() => {
          this.loading().close()
        })
      })
    },

    /**
     * loading
     */
    loading () {
      return {

        /**
         * 开启
         */
        open: () => {
          this.fullLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
        },

        /**
         * 关闭
         */
        close: () => {
          this.fullLoading.close()
        }
      }
    },

    /**
     * 获取历史数据
     */
    queryHistoryData () {
      if (this.deviceList.length > 0) {
        this.loading().open()
        GetWeatherHistorys({
          gatewayId: this.deviceList[0].gatewayid,
          startTime: dayjs(this.queryParams.startTime).format('YYYY-MM-DD 00:00:00'),
          endTime: dayjs(this.queryParams.endTime).format('YYYY-MM-DD 23:59:59'),
          dateType: 'date',
          orgId: this.$store.getters.station.id
        }).then(res => {
          this.setChartSeriesData(res.data)
        }).finally(() => {
          this.fullLoading.close()
        })
      }
    },

    /**
     * 查询
     */
    handleQuery () {
      this.queryHistoryData()
    },

    /**
     * 渲染图表
     */
    renderChart () {
      if (!this.chartInstance) {
        this.chartInstance = echarts.init(document.getElementById('weather_compare_div'))
      }
      this.chartInstance.setOption(
        this.chartOptions
      )
      this.chartLegendEvent()
    },

    /**
     * 图例点击事件
     */
    chartLegendEvent () {
      this.chartInstance.off('legendselectchanged')
      this.chartInstance.on('legendselectchanged', ({ selected }) => {
        this.chartLegendCall(selected)
      })
    },

    /**
     * 图例点击事件回调
     */
    chartLegendCall (selected) {
      let yAxisOffset = -65
      let firstShow = true
      Object.keys(selected).forEach((value, index) => {
        this.chartOptions.yAxis[index].show = selected[value]
        if (selected[value]) {
          this.chartOptions.yAxis[index].offset = yAxisOffset <= 0 ? 0 : yAxisOffset
          yAxisOffset += 65
          if (firstShow) {
            this.chartOptions.yAxis[index].position = 'left'
          } else {
            this.chartOptions.yAxis[index].position = 'right'
          }
          firstShow = false
        } else {
          this.chartOptions.yAxis[index].offset = 0
        }
      })
      this.renderChart()
    }
  }
}
</script>
<style scoped>
.weather-compare{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.weather-compare>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: none;
}
.weather-compare>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.weather-compare>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.weather-compare>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
